import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './components/ThemeProvider';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Testimonials from './pages/Testimonials';
import Contact from './pages/Contact';
import Booking from './pages/Booking';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';  // Add this import
import { Toaster } from './components/ui/sonner';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import Invoice from './pages/Invoice';
import InvoiceHistory from './pages/InvoiceHistory';

function App() {
  useEffect(() => {
    // Use system/browser preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    document.documentElement.classList.toggle('dark', prefersDark);
    
    // Listen for changes in system preference
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      document.documentElement.classList.toggle('dark', e.matches);
    };
    
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App min-h-screen bg-white dark:bg-[#0D1117] transition-colors duration-300">
          <Navbar />
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/booking" element={<Booking />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            
            {/* Protected Admin Routes - Require Login */}
            <Route path="/admin/dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/admin/invoice" element={
              <ProtectedRoute>
                <Invoice />
              </ProtectedRoute>
            } />

            <Route path="/admin/invoices" element={
              <ProtectedRoute>
                <InvoiceHistory />
              </ProtectedRoute>
            } />
          </Routes>
          <Footer />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;